export default __webpack_public_path__ + "static/media/SouthAmerica_04.ee62d759.png";